module.exports = __webpack_public_path__ + "img/ad179cb.jpg";